module.exports = __webpack_public_path__ + "img/about_home.de6a4a83.jpg";